/**
 * Solutions for Google PageSpeed Insights.
 * Consult AG before making updates.
 */

// Remove visibility: hidden; for CLS on page load
window.addEventListener('load', function() {
	document.body.style = '';
});

// Lazy-load JavaScript files on minimal user interaction (MUI)
var jsLoaded = false,
		jsLoading = false,
		mui = false,
		loadJS = function() {
			if(!jsLoaded && !jsLoading) {
				var script = document.querySelector('script[data-src]');

				if(script) {
					jsLoading = true;
					script.addEventListener('load', function() {
						jsLoading = false;
						loadJS();
					}, {once: true});
					script.addEventListener('error', function() {
						jsLoading = false;
						console.error('Unable to load site JavaScript.', script.src);
					}, {once: true});
					script.src = script.dataset.src;
					script.removeAttribute('data-src');
				} else {
					jsLoaded = true;
				}
			}

			// Trigger MUI for third-party scripts added in Google Tag Manager
			if(!mui) {
				if(typeof dataLayer !== 'undefined') {
					dataLayer.push({'event': 'minimal-user-interaction'});
				}

				mui = true;
			}
		};

document.addEventListener('focusin', loadJS, {once: true});
document.addEventListener('mousemove', loadJS, {once: true});
document.addEventListener('scroll', loadJS, {once: true});
document.addEventListener('touchstart', loadJS, {once: true});
document.addEventListener('keydown', loadJS, {once: true});
